import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Sport } from '__generated__/globalTypes';
import { useQuery } from 'hooks/graphql/useQuery';

import type {
  DeckQuery,
  DeckQueryVariables,
} from './__generated__/useDeck.graphql';
import { deckFragment } from './fragments';

const DECK_QUERY = gql`
  query DeckQuery($name: String!, $sport: Sport!) {
    currentUser {
      slug
      userSportProfile: anyUserSportProfile(sport: $sport) {
        id
        deck(name: $name) {
          slug
          cards(first: 50) {
            nodes {
              slug
            }
          }
          ...deckFragments_deck
        }
      }
    }
  }
  ${deckFragment}
` as TypedDocumentNode<DeckQuery, DeckQueryVariables>;

type Props = {
  sport: Sport;
  name?: string;
  skip?: boolean;
};

export const useDeck = ({ sport, name, skip: skipProp }: Props) => {
  const { data, loading } = useQuery(DECK_QUERY, {
    variables: {
      sport,
      name: name || '',
    },
    skip: !name || skipProp,
  });

  return {
    deck: data?.currentUser?.userSportProfile?.deck,
    loading,
  };
};
